 
    <p-spinner
      size="30"
      [(ngModel)]="this.field.value"
    ></p-spinner>
  